import { AritoFormV2, LoadingOverlayV2 } from '@/components/custom/erp';
import { FormBottomBar, FormTabs } from './FormTabs';
import type { FormDialogProps } from './types';
import InfoDropdown from './InfoDropdown';
import { FormHeader } from './FormHeader';
import { useFormDialog } from './hooks';

const FormDialog = (props: FormDialogProps) => {
  const dialog = useFormDialog(props);

  return (
    <div className='relative h-full min-h-0'>
      {dialog.loading && (
        <div className='absolute inset-0 z-50 flex items-center justify-center bg-white bg-opacity-80'>
          <LoadingOverlayV2 />
        </div>
      )}

      <AritoFormV2
        mode={dialog.formMode}
        initialData={dialog.initialValues}
        title={dialog.title}
        actionButtons={dialog.actionButtons}
        subTitle='Giấy báo nợ'
        onSubmit={dialog.submit}
        onClose={dialog.onClose}
        schema={dialog.schema}
        headerFields={FormHeader(dialog)}
        headerTabActions={
          dialog.formMode !== 'add' &&
          dialog.initialData?.uuid && (
            <InfoDropdown uuid={dialog.initialData.uuid} ma_ct={dialog.initialData?.chung_tu || undefined} />
          )
        }
        tabs={FormTabs(dialog)}
        bottomBar={FormBottomBar(dialog)}
      />
    </div>
  );
};

export default FormDialog;
